import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";

import { CloseOutlined } from "@mui/icons-material";
import {
  IAutomaticResponseHistory,
  Slot,
} from "./Models";
import Loading from "./Loading";
import Notification from "./Notification";
import {
  rescheduleAppointment,
  fetchAvailalbeAppointmentsForAutomaticResponseById,
} from "./DataServices/AppointmentsDataServices";

interface RescheduleAppointmentProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedTenants: IAutomaticResponseHistory[];
}

const RescheduleAppointment = ({
  open,
  setOpen,
  selectedTenants,
}: RescheduleAppointmentProps) => {
  const [loading, setLoading] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationMessageType, setNotificationMessageType] =
    useState("success");
  const [openNotification, setOpenNotification] = useState(false);

  const [availableAppointment, setAvailableAppointment] = useState<{
    [id: string]: Slot[];
  }>();

  const [selectedSlots, setSelectedSlots] = useState<{ [key: string]: string }>(
    {}
  );

  const handleSelectChange = (lId: string, slotId: string) => {

    setSelectedSlots((prevSelectedSlots) => ({
      ...prevSelectedSlots,
      [lId]: slotId,
    }));
  };

  useEffect(() => {
    if (availableAppointment) {
      const _selectedSlots: { [key: string]: string } = {};

      Object.keys(availableAppointment).forEach((tenantId) => {
        if (availableAppointment[tenantId]?.length > 0) {
          _selectedSlots[tenantId] = availableAppointment[tenantId][0].id; // Assign first slot id
        }
      });

      setSelectedSlots(_selectedSlots);
    }
  }, [availableAppointment]);

  const handleReshcheduleAppointment = async (selectedSlots: {
    [key: string]: string;
  }) => {
    try {
      setLoading(true);
      const response = await rescheduleAppointment(selectedSlots);
      
      setLoading(false);
      setOpen(false);
      setOpenNotification(true);
      setNotificationMessage("Appointment rescheduled successfully!");
      setNotificationMessageType("success");
      setTimeout(() => {
        setOpenNotification(false);
      }, 3000);
    } catch (error: any) {
      setLoading(false);
      setOpenNotification(true);
      setNotificationMessage("Appointment rescheduled failed!");
      setNotificationMessageType("error");
      setTimeout(() => {
        setOpenNotification(false);
      }, 3000);
      console.error("Failed to reschedule appointment:", error.message);
    }
  };

  useEffect(() => {
    const fetchAppointments = async () => {
      const appointmentDict: { [id: string]: Slot[] } = {};

      await Promise.all(
        selectedTenants.map(async (element) => {
          try {
            const fetchedSlots =
              await fetchAvailalbeAppointmentsForAutomaticResponseById(
                element.id
              );
            appointmentDict[element.id] = fetchedSlots;
          } catch (error) {
            console.error("Error fetching confirmed appointments:", error);
          }
        })
      );

      setAvailableAppointment(appointmentDict);
    };

    if (selectedTenants.length > 0) {
      fetchAppointments();
    }
  }, [open]);

  return (
    <>
    
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10 justify-center "
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed  w-screen flex  justify-center  inset-0 z-15  overflow-y-auto">
            <div className="flex min-h-full w-3/4 justify-center text-center items-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-[90%] max-h-[80vh] p-4 overflow-y-auto">
                  <div className="flex items-center justify-between gap-2">
                    <h2 className="font-semibold text-gray-700 p-2"> </h2>
                    <span
                      className="cursor-pointer active:scale-[0.98]"
                      onClick={() => setOpen(false)}
                    >
                      <CloseOutlined fontSize="small" />
                    </span>
                  </div>
                  <div className="flex flex-col items-center justify-center mb-4">
                    <h2 className="text-lg font-semibold mb-1">
                      Select New Slots For Tenants
                    </h2>
                  </div>
                  
                  <div className="mb-2">
                    <h2 className="font-semibold text-gray-700 p-2">
                      {/* Available Appartments */}
                    </h2>
                    <div className="relative overflow-x-auto shadow border rounded-lg mx-2">
                      <table className="w-full text-sm text-left rtl:text-right text-gray-600">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100">
                          <tr>
                            <th scope="col" className="px-6 py-3">
                              Email
                            </th>

                            <th scope="col" className="px-6 py-3">
                              Available Slot
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedTenants.map((l) => {
                            return (
                              <tr key={l.id} className="border-b">
                                <td className="px-6 py-3 truncate">
                                  {l.email}
                                </td>

                                <td className="px-6 py-3 truncate">
                                  <select
                                    className="border rounded pl-2 pr-8 py-1 text-sm"
                                    value={selectedSlots[l.id] || ""} // Default to empty if not selected
                                    onChange={(e) =>
                                      handleSelectChange(l.id, e.target.value)
                                    }
                                  >
                                    {(availableAppointment?.[l.id] ?? [])
                                      .length > 0 ? (
                                      (availableAppointment?.[l.id] ?? []).map(
                                        (slot, index) => (
                                          <option key={index} value={slot.id} className="text-sm">
                                            {new Date(
                                              slot.startTime
                                            ).toLocaleString("en-US", {
                                              month: "numeric",
                                              day: "numeric",
                                              year: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                              second: "numeric",
                                              hour12: true,
                                            })}{" "}
                                            -{" "}
                                            {new Date(
                                              slot.endTime
                                            ).toLocaleString("en-US", {
                                              month: "numeric",
                                              day: "numeric",
                                              year: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                              second: "numeric",
                                              hour12: true,
                                            })}
                                          </option>
                                        )
                                      )
                                    ) : (
                                      <option>No Slots Available</option>
                                    )}
                                  </select>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <div className="flex justify-center mt-4">
                      <button
                        className="bg-blue-600 text-white font-medium py-1.5 px-4 text-sm rounded-full"
                        onClick={() =>
                          handleReshcheduleAppointment(selectedSlots)
                        }
                      >
                        Reschedule appointment
                      </button>
                    </div>
                  </div>
                  {loading && (
                    <div className="absolute bg-gray-300/80 top-0 left-0 w-full h-full flex items-center justify-center">
                      <Loading />
                    </div>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Notification
        isOpen={openNotification}
        setIsOpen={setOpenNotification}
        message={notificationMessage}
        messageType={notificationMessageType}
      />
    </>
  );
};

export default RescheduleAppointment;
